module.exports = __webpack_public_path__ + "static/freiraum3-825db6a0355fe76e508effcd11b8d44c.png";